<script>
  import {
    stopPropagation,
  } from "./genericHandlers";
  import { soundBoard } from "./store";

  import Modal from "./Modal.svelte";

  import closeIcon from "./assets/close.svg?raw";

  export let scene;
  export let onSceneClosing;

  let showModal = false;
  const handleDeleteSceneRequested = () => {
    showModal = true;
  };
  const deleteScene = () => {
    soundBoard.DeleteScene(scene.id);
    showModal = false;
    if (onSceneClosing) {
      onSceneClosing(scene.id);
    }
  };
</script>

<button
  class="hover-target scene-close-button"
  aria-label="remove scene"
  on:click={handleDeleteSceneRequested}
  on:pointerdown={stopPropagation}
  on:mousedown={stopPropagation}
>
  {@html closeIcon}
</button>
<Modal bind:showModal>
  <p slot="header">Are you sure?</p>
  <div>
    <p>Are you sure you want to delete scene {scene.name}?</p>
    <div class="grid">
      <button class="contrast outline" on:click={deleteScene}>Yes</button>
      <button
        class="contrast outline"
        on:click={() => {
          showModal = false;
        }}>No</button
      >
    </div>
  </div>
</Modal>
